import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'numberSmall'
})
export class NumberSmallPipe implements PipeTransform {

  transform(value: string): string {
    const evalValue = parseInt(value);
    if (evalValue < 1000) return evalValue.toString();
    if (evalValue >= 1000 && evalValue < 1000000) return `${(evalValue / 1000).toString()}K`;
    if (evalValue >= 1000000) return `${(evalValue / 1000000).toString()}M`;
    return evalValue.toString();
  }
}


// WEBPACK FOOTER //
// ./src/pipes/number-small.pipe.ts